
export default {
    inputAdornment: {
        fontSize: 27,
    }

}